import 'leaflet/dist/leaflet.css';
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import { useEffect, useState } from "react";
import L from 'leaflet';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';
import { api } from '../utils/apiClient';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

const createIcon = (color) => new L.Icon({
  iconUrl: 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="40" viewBox="0 0 24 24" fill="${color}" stroke="#FFFFFF" stroke-width="1.5">
      <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.53L12 21.35z"/>
      <circle cx="12" cy="8.5" r="3" fill="#FFFFFF" stroke="none"/>
    </svg>`),
  iconSize: [30, 40],
  iconAnchor: [15, 40],
  popupAnchor: [0, -40]
});

const activeIcon = createIcon('#22c55e');
const inactiveIcon = createIcon('#9ca3af');
const selectedIcon = createIcon('#3B82F6');

function RecenterToAbogado({ activeLocation }) {
  const map = useMap();
  useEffect(() => {
    if (activeLocation && activeLocation.lat && activeLocation.lng) {
      map.setView([activeLocation.lat, activeLocation.lng], 15);
    }
  }, [activeLocation, map]);
  return null;
}

export default function DeviceMap({ activeLocation }) {
  const [devices, setDevices] = useState([]);

  const fetchData = async () => {
    try {
      const data = await api.get('/geolocation/all');
      const arr = Array.isArray(data) ? data : (data.data || []);
      setDevices(arr);
    } catch (error) {
      console.error("Error cargando mapa:", error);
    }
  };

  useEffect(() => {
    fetchData();
    const interval = setInterval(fetchData, 8000);
    return () => clearInterval(interval);
  }, []);

  const center = (activeLocation?.lat) ? [activeLocation.lat, activeLocation.lng] : [4.624335, -74.063644];

  // Dispositivos activos (en vivo)
  const activeDevices = devices.filter(d => d.enabled && d.lat != null);
  // Dispositivos con ultimo punto conocido (no activos)
  const lastKnownDevices = devices.filter(d => !d.enabled && d.last_lat != null);

  return (
    <MapContainer center={center} zoom={13} style={{ height: "100%", width: "100%" }}>
      <TileLayer url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png" />

      {/* Marcadores activos (verde) */}
      {activeDevices.map((dev) => (
        <Marker key={`active-${dev.user_id}`} position={[dev.lat, dev.lng]} icon={activeIcon}>
          <Popup>
            <strong>{dev.nombre || `Usuario #${dev.user_id}`}</strong><br />
            <span style={{ color: '#22c55e' }}>En linea</span><br />
            {new Date(dev.timestamp).toLocaleTimeString()}
          </Popup>
        </Marker>
      ))}

      {/* Marcadores ultimo punto (gris) */}
      {lastKnownDevices.map((dev) => (
        <Marker key={`last-${dev.user_id}`} position={[dev.last_lat, dev.last_lng]} icon={inactiveIcon}>
          <Popup>
            <strong>{dev.nombre || `Usuario #${dev.user_id}`}</strong><br />
            <span style={{ color: '#9ca3af' }}>Offline - Ultimo punto</span><br />
            {dev.last_active_at ? new Date(dev.last_active_at).toLocaleString() : '-'}
          </Popup>
        </Marker>
      ))}

      {/* Marcador seleccionado (azul) */}
      {activeLocation && activeLocation.lat && (
        <Marker position={[activeLocation.lat, activeLocation.lng]} icon={selectedIcon}>
          <Popup><strong>Rastreando:</strong> {activeLocation.name || 'Abogado'}</Popup>
        </Marker>
      )}

      <RecenterToAbogado activeLocation={activeLocation} />
    </MapContainer>
  );
}
